import {
  PAGINATION_SET_ITEM_PER_PAGE,
} from '../mutation-types';


// state
const localState = {
  itemPerPageList: [
    50,
    100
  ],
  itemPerPage: 50,
};

// mutations
const mutations = {
  [PAGINATION_SET_ITEM_PER_PAGE]() {

  },
};

// actions
const actions = {

};

export default {
  state: localState,
  mutations,
  actions,
};
